// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1q0vT","alertIcon":"ConfirmModal_alertIcon__3CuLm"};